import * as S from './DetailsModal.styles';

const normaliseKey = (key: string) => key.replace(/([A-Z])/g, ' $1').trim();

const renameProperty = (key: string) => {
  switch (key) {
    case 'id':
      return 'Order Number';
    case 'userCode':
      return 'User Alias';
    case 'customerName':
      return "Client's Name";
    case 'createdAt':
      return 'Date of Dispatch';
    case 'status':
      return 'State';
    default:
      return normaliseKey(key);
  }
};

export const shouldShow = (item: any): any => {
  const { key, value } = item;
  if (key === 'action' || !value || value.length === 0) {
    return null;
  }

  switch (typeof value) {
    case 'string':
      return (
        <S.listItem key={key}>
          <S.key>{renameProperty(key)}</S.key>
          <S.value>{value}</S.value>
        </S.listItem>
      );
    case 'object':
      if (Array.isArray(value)) {
        return (
          <S.listItem key={key}>
            <S.key>{key}</S.key>
            {value.map((v: string, idx: number) => (
              <S.value key={v}>
                {v}
                {value.length > 0 && idx < value.length - 1 && ', '}
              </S.value>
            ))}
          </S.listItem>
        );
      }
      return (
        <S.listItem key={key}>
          <S.key>{key}</S.key>
          <S.value>{value.value}</S.value>
        </S.listItem>
      );
    default:
      return `Unknown type: ${typeof value}`;
  }
};
